<!-- eslint-disable vue/no-bare-strings-in-template -->
<template>
  <overlay
    key="cartDrawer"
    block-class="cart-drawer-overlay"
    direction="left"
    namespace="cartDrawer"
    type="drawer"
    :overlay-label="$string('cart.title_empty')"
  >
    <template #body="overlay">
      <cart-drawer
        v-if="loadDrawer"
        v-cloak
        :overlay="overlay"
        :section="section"
      />
    </template>
  </overlay>
</template>

<script>

/**
 * Vue: Cart drawer overlay (cart-drawer-overlay)
 * -----------------------------------------------------------------------------
 * Displays cart overlay.
 *
 * @param {Object} section - Shopify section settings.
 *
 */
// eslint-disable-next-line import/named
import { mapActions } from 'vuex'

import Overlay from '~global/overlay/overlay'
import CartDrawer from '~global/cart-group/cart-drawer/cart-drawer'

export default {
  name: 'CartDrawerOverlay',

  components: {
    Overlay,
    CartDrawer,
  },

  props: {
    section: {
      type: Object,
      default: () => ({
        dynamicYieldTarget: null,
      }),
    },
  },

  data() {
    return {
      loadDrawer: true,
    }
  },

  mounted() {
    window.cnvs?.EventBus?.listen('overlay:open-cart-drawer', async() => {
      if (!this.loadDrawer) {
        this.loadDrawer = true
        return
      }

      await this.$nextTick()

      this.openOverlay({
        component: 'cart-drawer',
        ignoreDismissed: true,
        namespace: 'cartDrawer',
      })
    })
  },

  methods: {

    /**
     * Map Vuex actions.
     */
    ...mapActions({
      openOverlay: 'overlays/open',
    }),
  },
}
</script>
